import React from 'react';

import PageLayout from 'PageLayout';
import { EButton, EFormSection, EPageTitle, ETextInput } from 'libs/ui';

import useAddNewAccount from './Hooks/useAddNewAccount';

export default function AddNewAccount() {

    const {
        navigate,
        accountDetails,
        handleUpdateAccountDetails,
        isSaving,
        saveAccountDetails
    } = useAddNewAccount();

    return (
        <PageLayout>
            <EPageTitle
                title="Account Details"
                end={
                    <div className="flex gap-2">
                        <EButton
                            disabled={isSaving}
                            variant="outline"
                            onClick={() => navigate("/admin/accounts")}
                        >Cancel</EButton>
                        <EButton
                            loading={isSaving}
                            onClick={saveAccountDetails}
                        >Create New</EButton>
                    </div>
                }
            />
            <EFormSection
                fullWidth
                title="Account Details"
                subtitle="Fill the mandatory (*) details"
            >
                <div className="grid grid-cols-3 gap-6">
                    <ETextInput
                        label="Bank Name"
                        placeholder="Enter Bank Name"
                        required={accountDetails.rules.bankName === "YES"}
                        value={accountDetails.details.bankName ?? undefined}
                        error={accountDetails.errors.bankName}
                        onChange={(e) => handleUpdateAccountDetails("bankName", e.target.value)}
                    />

                    <ETextInput
                        label="Bank Address"
                        placeholder="Enter Bank Address"
                        required={accountDetails.rules.bankAddress === "YES"}
                        value={accountDetails.details.bankAddress ?? undefined}
                        error={accountDetails.errors.bankAddress}
                        onChange={(e) => handleUpdateAccountDetails("bankAddress", e.target.value)}
                    />

                    <ETextInput
                        label="Branch"
                        placeholder="Enter Branch"
                        required={accountDetails.rules.branch === "YES"}
                        value={accountDetails.details.branch ?? undefined}
                        error={accountDetails.errors.branch}
                        onChange={(e) => handleUpdateAccountDetails("branch", e.target.value)}
                    />

                    <ETextInput
                        label="Account Number"
                        placeholder="Enter Account Number"
                        required={accountDetails.rules.accountNumber === "YES"}
                        value={accountDetails.details.accountNumber ?? undefined}
                        error={accountDetails.errors.accountNumber}
                        onChange={(e) => handleUpdateAccountDetails("accountNumber", e.target.value)}
                    />

                    <ETextInput
                        label="Account Name"
                        placeholder="Enter Account Name"
                        required={accountDetails.rules.accountName === "YES"}
                        value={accountDetails.details.accountName ?? undefined}
                        error={accountDetails.errors.accountName}
                        onChange={(e) => handleUpdateAccountDetails("accountName", e.target.value)}
                    />

                    <ETextInput
                        label="IFSC Code"
                        placeholder="Enter IFSC Code"
                        required={accountDetails.rules.ifsccode === "YES"}
                        value={accountDetails.details.ifsccode ?? undefined}
                        error={accountDetails.errors.ifsccode}
                        onChange={(e) => handleUpdateAccountDetails("ifsccode", e.target.value)}
                    />

                    <ETextInput
                        label="System Code"
                        placeholder="Enter System Code"
                        required={accountDetails.rules.systemCode === "YES"}
                        value={accountDetails.details.systemCode ?? undefined}
                        error={accountDetails.errors.systemCode}
                        onChange={(e) => handleUpdateAccountDetails("systemCode", e.target.value)}
                    />

                    {/* <ETextInput
                        label="Challan Id"
                        placeholder="Enter Challan Id"
                        required={accountDetails.rules.challanId === "YES"}
                        value={accountDetails.details.challanId ?? undefined}
                        error={accountDetails.errors.challanId}
                        onChange={(e) => handleUpdateAccountDetails("challanId", e.target.value)}
                    /> */}

                    <ETextInput
                        label="MIC Number"
                        placeholder="Enter MIC Number"
                        required={accountDetails.rules.micnumber === "YES"}
                        value={accountDetails.details.micnumber ?? undefined}
                        error={accountDetails.errors.micnumber}
                        onChange={(e) => handleUpdateAccountDetails("micnumber", e.target.value)}
                    />
                </div>
            </EFormSection>
        </PageLayout>
    );

}